'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dCompat$0024 from "./scala.scalajs.runtime.-Compat$.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$() {
}
export { $c_Lcom_raquo_ew_JsArray$ as $c_Lcom_raquo_ew_JsArray$ };
$p = $c_Lcom_raquo_ew_JsArray$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_ew_JsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$() {
}
export { $h_Lcom_raquo_ew_JsArray$ as $h_Lcom_raquo_ew_JsArray$ };
$h_Lcom_raquo_ew_JsArray$.prototype = $p;
$p.db = (function(items) {
  return [...$j_scala$002escalajs$002eruntime$002e$002dCompat$0024.$m_sjsr_Compat$().Y8(items)];
});
var $d_Lcom_raquo_ew_JsArray$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_ew_JsArray$, "com.raquo.ew.JsArray$", ({
  hq: 1
}));
export { $d_Lcom_raquo_ew_JsArray$ as $d_Lcom_raquo_ew_JsArray$ };
var $n_Lcom_raquo_ew_JsArray$;
function $m_Lcom_raquo_ew_JsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$)) {
    $n_Lcom_raquo_ew_JsArray$ = new $c_Lcom_raquo_ew_JsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$;
}
export { $m_Lcom_raquo_ew_JsArray$ as $m_Lcom_raquo_ew_JsArray$ };
